import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaggageComponent } from './baggage.component';
import { TextTooltipModule } from '@lib/components';
import { AmountFormatModule, StaticMsgModule } from '@lib/pipes';
import { TableSliderModule } from '@common/components/feature-part/table-slider/table-slider.module';
import { BaggageItemModule } from './baggage-item/baggage-item.module';
import { CallCenterBaggageItemModule } from './call-center-baggage-item/call-center-baggage-item.module';
import { TooltipDirectiveModule } from '@lib/directives';
import { TextWithTooltipModule } from '@common/components/text-with-tooltip/text-with-tooltip.module';

@NgModule({
  declarations: [BaggageComponent],
  imports: [
    CommonModule,
    TextTooltipModule,
    TooltipDirectiveModule,
    TableSliderModule,
    StaticMsgModule,
    AmountFormatModule,
    BaggageItemModule,
    CallCenterBaggageItemModule,
    TextWithTooltipModule,
  ],
  exports: [BaggageComponent],
})
export class BaggageModule {}
